import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/my-organization")({
  staticData: { title: "My organization" },
  component: () => <Outlet />,
});
